import axios from './base'
const url = `/dict`

// ================= 字典管理（后端 DictService，mg_dict，/dict*） =================

// 分组列表（固定 8 组，后端 App\Constants\DictCode 维护）
// 返回 data:{list:[{dict_code,dict_name,value_style}]}
export function getDictGroups(params = {}) {
  return axios.request({
    url: `${url}/groups`,
    method: "get",
    params,
  })
}

// 批量取字典（前端初始化用）：codes 逗号分隔
// 只返回启用项，按 sort 升序；返回 data:{ activity_category:[...], ... }
export function getDictMap(params = {}) {
  return axios.request({
    url: `${url}/map`,
    method: "get",
    params,
  })
}

// 某分组选项列表（全量不分页）：keyword 显示名/值模糊、status 1启用 0停用
// 返回 data:{list:[{_id,dict_code,label,value,sort,status,updated_at}]}
export function getDictList(dictCode, params = {}) {
  return axios.request({
    url: `${url}/${dictCode}`,
    method: "get",
    params,
  })
}

// 新增选项（value_style=text 的组，后端强制 value=label；code 组校验小写编码格式）
export function createDictItem(dictCode, data = {}) {
  return axios.request({
    url: `${url}/${dictCode}`,
    method: "post",
    data,
  })
}

// 编辑选项（value 保存后不可改：后端忽略传入值，业务数据引用它）
export function updateDictItem(dictCode, id, data = {}) {
  return axios.request({
    url: `${url}/${dictCode}/${id}`,
    method: "put",
    data,
  })
}

// 删除选项（仅超管；被业务数据引用的拦截待业务模块上线后补）
export function deleteDictItem(dictCode, id, data = {}) {
  return axios.request({
    url: `${url}/${dictCode}/${id}`,
    method: "delete",
    data,
  })
}

// 启用/停用（body: {status: 0|1}；停用后业务表单不再出现，已存数据不受影响）
export function updateDictStatus(dictCode, id, data = {}) {
  return axios.request({
    url: `${url}/${dictCode}/${id}/status`,
    method: "put",
    data,
  })
}
